export default __webpack_public_path__ + "static/media/createCourseWhite.3141de7c.svg";